/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import axios from 'axios';
import { CotizadorContext } from '../context';

const useCarsData = () => {
    const [state, setState] = useContext(CotizadorContext)

    const getCars = async () => {
        const response = await axios.get('/api/kinto/cars');
        setState(prevState => ({
            ...prevState,
            available_cars: response?.data
        }))
    }

    const getSelectedCar = () => {
        if (state.selected_car) {
            return state.available_cars.find(car => car.id === state.selected_car);
        }

        return null;
    }

    const setSelectedCar = selected_car => {
        setState(prevState => ({
            ...prevState,
            selected_car
        }));
    }

    return {
        cars: state.available_cars,
        getSelectedCar,
        setSelectedCar,
        getCars
    };
}

export default useCarsData;